import React from "react";
import caseback from "../../Assets/caseback.png";
import "./casestudy.css";

const Casestudy = () => {
    return (
        <>
            <div className="study-container">
                <div className="study-back">
                    <img src={caseback} className="study-imgback" alt="back" />
                </div>
                <div className="Study-content">
                    <h1 className="study-topic"><span style={{ color: "#Ff6600", fontFamily: "'Glacial Indifference',sans-serif"}}>CASE</span> STUDY</h1>
                    <span className="study-subtopic">
                        <span style={{  fontFamily: "'Glacial Indifference',sans-serif"}}>FROM ZERO TO 15 FRANCHISES IN 5 MONTHS</span>:<br /><span
                            style={{ fontFamily: "'Glacial Indifference',sans-serif"}}>"HOW STRATEGIC
                            MARKETING FUELED INDIA'S PREMIUM CAR CARE REVOLUTION"</span>
                    </span>
                    <span className="study-para">As the exclusive marketing partner for 3d car care india, we engineered a results-driven strategy to position them as india's most trusted premium automotive care brand. within just 5 months (october
                        2024 - february 2025), our campaigns secured 15
                        franchise partnerships nationwide while amplifying
                        their digital presence across all platforms
                    </span>
                </div>
            </div>
        </>
    )
}

export default Casestudy;